import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import Icon from '../Icon';

/**
 *  A React component that renders a loading indicator.
 * if progress is not provided, it will render an infinite loading indicator
 * if progress is provided, it will render a progress bar
 * Optionally a textBlock can be provided to display a message
 */
function LoadingIndicatorProgress({ className, textBlock, progress, style }) {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = `HarpiAI APP | ${t('Common:Loading')}`;
  }, []);

  return (
    <div
      className={classNames(
        'absolute top-0 left-0 z-50 flex h-full w-full flex-col items-center justify-center bg-black/50 transition-all duration-300',
        className
      )}
      style={style ? { ...style } : {}}
    >
      <div className="relative flex items-center justify-center">
        <div className="absolute h-24 w-24 rounded-full bg-[#1C45BD] opacity-30 blur-2xl animate-pulse"></div>

        <div className="absolute h-40 w-40 rounded-full border-[6px] border-[#1C45BD] opacity-10"></div>

        <div
          className="absolute h-40 w-40 animate-spin rounded-full border-[6px] border-transparent border-t-[#1C45BD] border-r-[#1C45BD66]"
          style={{ filter: 'drop-shadow(0 0 12px rgba(28,69,189,0.8))' }}
        ></div>

        <div
          className="absolute h-32 w-32 animate-spin rounded-full border-[4px] border-transparent border-b-[#638EFF] border-l-[#638EFF66]"
          style={{ animationDuration: '0.8s', animationDirection: 'reverse' }}
        ></div>

        <div className="absolute flex items-center justify-center z-10">
          <Icon
            name="loading-harpiAI-mark"
            className="h-12 w-12 text-white drop-shadow-[0_0_10px_rgba(255,255,255,0.4)] animate-pulse"
          />
        </div>
      </div>

      {textBlock && (
        <div className="mt-6 text-white font-medium text-lg tracking-wide opacity-90 animate-pulse">
          {textBlock}
        </div>
      )}
    </div>
  );
}

export default LoadingIndicatorProgress;
